import { TextField } from '@mui/material';
import styled from 'styled-components';

export const CurveDialogForm = styled.form``;

export const Input = styled(TextField)`
	background-color: white !important;
`;
